import React from "react";
import { Link } from "react-router-dom";

const TourPackageCard = ({
  title,
  pricing,
  features,
  imageUrl,
  duration,
  itinerary,
  inclusions,
  exclusions,
  carousalImages,
}) => {
  return (
    <Link
      to={`/packages/${title}`}
      state={{
        title,
        pricing,
        features,
        duration,
        imageUrl,
        itinerary,
        inclusions,
        exclusions,
        carousalImages
      }}
    >
      <div className="bg-white rounded-lg overflow-hidden shadow-lg m-4 transform transition-transform duration-300 hover:scale-105 hover:shadow-xl">
        <div className="relative">
          <img
            src={carousalImages}
            alt={title}
            className="w-full h-48 object-cover"
          />
          <div className="absolute bottom-0 left-0 bg-black bg-opacity-50 text-white p-4 w-full">
            <h3 className="text-xl font-bold">{title}</h3>
            <p className="text-lg">Starting Pricing - {pricing}/-</p>
          </div>
        </div>
        <div style={{ background: "#fdf6ea" }} className="p-4">
          <ul className="list-disc list-inside space-y-2">
            {features.map((feature, index) => (
              <li key={index}>{feature}</li>
            ))}
          </ul>
          <div className="mt-4 w-full text-center">
            <button className="w-full text-white px-4 bg-indigo-500 hover:bg-indigo-700 py-2 rounded-full font-bold transform transition-transform duration-300 hover:scale-105 shadow-md">
              BOOK NOW
            </button>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default TourPackageCard;
